import React, { useEffect, useState } from 'react';
import { v2_categories, v2_channels } from '../../../actions/v2/masterData';
import { useDebouncedValue } from '../../../customHook/useDebouncedValue';

const Filter = ({ keyword, setKeyword, groupBy, setGroupBy, initialFilter = {}, onChangeFilter = () => {} }) => {

    const [state, setState] = useState({
        channel: { name: 'channel', value: initialFilter.channelId || '', options: [] },
        status: { name: 'status', value: initialFilter.status || '', options: ['Draft', 'Open', 'Close'] },
        category: { name: 'category', value: initialFilter.categoryId || '', options: [] },
        fromDate: { name: 'fromDate', value: initialFilter.fromDate || '' },
        toDate: { name: 'toDate', value: initialFilter.toDate || '' },
        hasMyComment: { name: 'hasMyComment', value: Boolean(initialFilter.hasMyComment) },
        hasDraftReply: { name: 'hasDraftReply', value: Boolean(initialFilter.hasDraftReply) },
    });

    // Typing updates the box instantly; the list only refetches once typing settles.
    const [searchText, setSearchText] = useState(keyword);
    const debouncedSearch = useDebouncedValue(searchText);

    useEffect(() => {
        if (debouncedSearch !== keyword) setKeyword(debouncedSearch);
    }, [debouncedSearch]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleGroupChange = (group) => {
        setGroupBy(group);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }));
    };

    useEffect(() => {
        onChangeFilter({
            channelId: state.channel.value,
            categoryId: state.category.value,
            status: state.status.value,
            fromDate: state.fromDate.value,
            toDate: state.toDate.value,
            hasMyComment: state.hasMyComment.value,
            hasDraftReply: state.hasDraftReply.value,
        });
    }, [state]);

    useEffect(() => {
        v2_channels().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    channel: {
                        ...prev.channel,
                        options: res.result.map((item) => ({
                            label: item.CHANNEL_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        });

        v2_categories().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    category: {
                        ...prev.category,
                        options: res.result.map((item) => ({
                            label: item.CATEGORY_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        });
    }, []);

    return (
        <>
            <div className="filter-paln">
                <div className="search-section-box">
                    <form className="app-search ">
                        <div className="position-relative">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Company/Project name..."
                                value={searchText}
                                onChange={handleSearchChange}
                            />
                            <span className="bx bx-search-alt" />
                        </div>
                    </form>
                </div>
                <ul>
                    <li>
                        <a href="javascript:void(0);"
                            onClick={() => handleGroupChange('none')}
                        >
                            <i
                                className="fa fa-list"
                                style={{ fontSize: groupBy === 'none' ? 19 : 15 }}
                            />{' '}
                            List
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"
                            onClick={() => handleGroupChange('company')}
                        >
                            <i
                                className="fa fa-building"
                                style={{ fontSize: groupBy === 'company' ? 19 : 15 }}
                            />{' '}
                            By Company
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"
                            onClick={() => handleGroupChange('shipyard')}
                        >
                            <i
                                className="bx bxs-ship"
                                style={{ fontSize: groupBy === 'shipyard' ? 19 : 15 }}
                            />{' '}
                            By Shipyard
                        </a>
                    </li>
                </ul>
            </div>

            <div className="col-md-12 ">
                <div className="plan-approval-index-top">
                    <div className="filter-tab-channels-box">
                        <div className="input-box">
                            <select className="form-select w200"
                                name={state.channel.name}
                                value={state.channel.value}
                                onChange={handleChange}
                            >
                                <option value="">Channels </option>
                                {state.channel.options.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="input-box">
                            <select className="form-select" style={{ width: 180 }}
                                name={state.category.name}
                                value={state.category.value}
                                onChange={handleChange}
                            >
                                <option value="">Categories</option>
                                {state.category.options.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className={state.hasMyComment.value ? 'input-box active' : 'input-box'}>
                            <button type="button"
                                onClick={() =>
                                    handleChange({
                                        target: {
                                            name: 'hasMyComment',
                                            value: !state.hasMyComment.value,
                                        },
                                    })
                                }
                            >
                                <i className="fa fa-edit" /> Has My Comments
                            </button>
                        </div>
                        <div className={state.hasDraftReply.value ? 'input-box active' : 'input-box'}>
                            <button type="button"
                                onClick={() =>
                                    handleChange({
                                        target: {
                                            name: 'hasDraftReply',
                                            value: !state.hasDraftReply.value,
                                        },
                                    })
                                }
                            >
                                <i className="fa fa-edit" /> Has Draft Reply
                            </button>
                        </div>
                        <div className="input-box">
                            <select className="form-select" style={{ width: 180 }}
                                name={state.status.name}
                                value={state.status.value}
                                onChange={handleChange}
                            >
                                <option value={''}>Status</option>
                                {state.status.options.map((option) => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                        <div className="input-box">
                            <input
                                className="form-control"
                                type="text"
                                onFocus={(e) => (e.target.type = "date")}
                                onBlur={(e) => !e.target.value && (e.target.type = "text")}
                                placeholder="From Date"
                                onChange={handleChange}
                                value={state.fromDate.value}
                                name={state.fromDate.name}
                            />
                        </div>
                        <div className="input-box">
                            <input
                                className="form-control"
                                type="text"
                                onFocus={(e) => (e.target.type = "date")}
                                onBlur={(e) => !e.target.value && (e.target.type = "text")}
                                placeholder="To Date"
                                onChange={handleChange}
                                value={state.toDate.value}
                                name={state.toDate.name}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Filter;
